export enum RewardModes {
  PreJoin,
  Saving,
  JustJoined,
  Joined,
  NoAccess
}
